/**
 * Static page registry (excludes blog — dynamic CMS content).
 * FR routes stay unchanged; EN routes use /en/... prefix.
 */
export const PAGE_REGISTRY = [
  { id: 'home', file: 'HomePage.js', fr: '/', en: '/en' },
  { id: 'about', file: 'AboutPage.js', fr: '/a-propos-agence-web-sherbrooke', en: '/en/about' },
  { id: 'contact', file: 'ContactPage.js', fr: '/contact-agence-web-sherbrooke', en: '/en/contact' },
  { id: 'portfolio', file: 'PortfolioPage.js', fr: '/portfolio-realisations-web', en: '/en/portfolio' },
  { id: 'soumission', file: 'SoumissionPage.js', fr: '/soumission-projet-web-gratuit', en: '/en/free-quote' },
  { id: 'services-hub', file: 'ServicesHubPage.js', fr: '/services', en: '/en/services' },
  { id: 'faq', file: 'FAQPage.js', fr: '/faq', en: '/en/faq' },
  { id: 'sitemap', file: 'SitemapPage.js', fr: '/plan-du-site', en: '/en/sitemap' },
  { id: 'newsletter', file: 'NewsletterPage.js', fr: '/newsletter', en: '/en/newsletter' },
  { id: 'newsletter-unsubscribe', file: 'NewsletterUnsubscribePage.js', fr: '/newsletter/unsubscribe', en: '/en/newsletter/unsubscribe' },
  { id: 'not-found', file: 'NotFoundPage.js', fr: null, en: null },

  { id: 'web-development', file: 'WebDevelopmentPage.js', fr: '/services/conception-site-web-sherbrooke', en: '/en/services/web-design' },
  { id: 'ecommerce', file: 'ECommercePage.js', fr: '/services/boutique-en-ligne-ecommerce', en: '/en/services/ecommerce' },
  { id: 'custom-saas', file: 'CustomSaaSPage.js', fr: '/services/developpement-saas-sur-mesure', en: '/en/services/custom-saas' },
  { id: 'marketing-crm', file: 'MarketingCRMPage.js', fr: '/services/marketing-crm-automation', en: '/en/services/marketing-crm' },
  { id: 'it-cloud', file: 'ITCloudPage.js', fr: '/services/support-informatique-microsoft365-google', en: '/en/services/it-cloud-support' },
  { id: 'photography', file: 'PhotographyPage.js', fr: '/services/photographie-video-corporative', en: '/en/services/photography-video' },
  { id: 'publicite-ads', file: 'PubliciteAdsPage.js', fr: '/services/publicite-google-ads-facebook', en: '/en/services/google-ads' },
  { id: 'logo-design', file: 'LogoDesignPage.js', fr: '/services/design-logo-entreprise', en: '/en/services/logo-design' },
  { id: 'branding', file: 'BrandingIdentityPage.js', fr: '/services/identite-visuelle-branding', en: '/en/services/branding' },
  { id: 'crunkycat', file: 'CrunkyCatMediaPage.js', fr: '/services/crunkycat-media-visuels', en: '/en/services/crunkycat-media' },
  { id: 'email-pro', file: 'EmailProfessionnelPage.js', fr: '/services/courriels-professionnels', en: '/en/services/professional-email' },
  { id: 'hosting-domains', file: 'HebergementDomainesPage.js', fr: '/services/hebergement-domaines', en: '/en/services/hosting-domains' },
  { id: 'business-cards', file: 'CartesAffairesPage.js', fr: '/services/cartes-affaires', en: '/en/services/business-cards' },
  { id: 'cloud-storage', file: 'StockageCloudPage.js', fr: '/services/stockage-cloud', en: '/en/services/cloud-storage' },
  { id: 'chatbots', file: 'ChatbotsMessagingPage.js', fr: '/services/chatbots-messagerie', en: '/en/services/chatbots' },
  { id: 'ai-integration', file: 'IntegrationIATravailPage.js', fr: '/services/integration-ia-travail', en: '/en/services/ai-integration' },
  { id: 'e-signature', file: 'SignatureElectroniquePage.js', fr: '/services/signature-electronique', en: '/en/services/e-signature' },
  { id: 'backup', file: 'SauvegardeDonneesPage.js', fr: '/services/sauvegarde-donnees', en: '/en/services/data-backup' },
  { id: 'business-advice', file: 'ConseilsAffairesPage.js', fr: '/services/conseils-affaires', en: '/en/services/business-consulting' },
  { id: 'web-content', file: 'CreationContenuWebPage.js', fr: '/services/creation-contenu-web', en: '/en/services/web-content' },
  { id: 'home-photography', file: 'PhotographieDomicilePage.js', fr: '/services/photographie-domicile', en: '/en/services/home-photography' },
  { id: 'shopify-stores', file: 'BoutiquesEnLignePage.js', fr: '/services/boutiques-en-ligne-shopify', en: '/en/services/shopify-stores' },
  { id: 'shopify-partner', file: 'ShopifyPartnerPage.js', fr: '/Tiguidou-web-Partenaire-Shopify-vente-enligne', en: '/en/shopify-partner' },

  { id: 'aica-hub', file: 'AicaHubPageFr.js', fr: '/aica', en: '/en/aica' },
  { id: 'aica-demo', file: 'AicaDemoPage.js', fr: '/aica/demo-chat-intelligence-artificielle', en: '/en/aica/demo' },
  { id: 'aica-business', file: 'AicaBusinessPage.js', fr: '/aica/solutions-ia-entreprise', en: '/en/aica/business-solutions' },
  { id: 'aica-chatbot', file: 'GetYourBotPage.js', fr: '/aica/creation-chatbot-sur-mesure', en: '/en/aica/custom-chatbot' },

  { id: 'privacy', file: 'PrivacyPolicyPage.js', fr: '/politique-confidentialite', en: '/en/privacy-policy' },
  { id: 'cookies', file: 'PolitiqueCookiesPage.js', fr: '/politique-cookies', en: '/en/cookie-policy' },
  { id: 'terms', file: 'TermsConditionsPage.js', fr: '/conditions-utilisation', en: '/en/terms-of-use' },
  { id: 'terms-of-sale', file: 'ConditionsVentePage.js', fr: '/conditions-vente', en: '/en/terms-of-sale' },
];

/** Shared shell (header, footer, etc.) */
export const SHELL_CONTENT_IDS = ['common', 'nav', 'footer'];

export function getPageById(id) {
  return PAGE_REGISTRY.find((p) => p.id === id);
}

export function getPageByRoute(pathname) {
  const normalized = pathname.replace(/\/$/, '') || '/';
  return PAGE_REGISTRY.find((p) => p.fr === normalized || p.en === normalized);
}

export function buildLocalePairs() {
  return PAGE_REGISTRY.filter((p) => p.fr && p.en).map((p) => ({ fr: p.fr, en: p.en }));
}

export function buildEnPrerenderRoutes() {
  return PAGE_REGISTRY.filter((p) => p.en).map((p) => p.en);
}
